// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20r23","textarea":"styles_textarea__2IDAo"};